import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-map-legend',
  templateUrl: './map-legend.component.html',
  styleUrls: ['./map-legend.component.less']
})
export class MapLegendComponent implements OnInit {

  @Input() heatMapColors : Array<any>;
  topLabels : Array<string>;
  constructor() { }

  ngOnInit() {
    this.topLabels = [];

    for(let i = 0; i < this.heatMapColors.length; i++) {
      if(this.heatMapColors[i].topLabel) {
        this.topLabels.push(this.heatMapColors[i].topLabel);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/map-legend/map-legend.component.ts